import { Message } from '../../../Hooks/useLangflowChat';
import './LangflowMessageItem.scss';
import { LangflowFeedback } from '../LangflowFeedback/LangflowFeedback';
import MarkdownFormattedText from 'components/MarkdownFormattedText/MarkdownFormattedText';

export interface LangflowMessageProps {
  message: Message;
}

export const LangflowMessageItem = ({ message }: LangflowMessageProps) => {
  return (
    <div
      key={message.id}
      className={`langflow-chat-message-container langflow-chat-message-container-${message.sender}`}
    >
      <div
        className={`langflow-chat-message-content langflow-chat-message-content-${message.sender}`}
      >
        <MarkdownFormattedText text={message.content} className="langflow-chat-message-text" />

        {message.sender === 'Machine' && <LangflowFeedback lastBotMessage={message} />}
      </div>
    </div>
  );
};
